import React from 'react';
import Modal from 'react-modal';
const customStyles = {
    content: {
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        marginRight: '-50%',
        transform: 'translate(-50%, -50%)',
        background: '#f9f9f9',
        padding: '24px'
    },
    overlay: {
        background: "#00000080"
    }
};

const HistoryModal =({ isOpen, onClose, datas})=>{

    return (
        <Modal
            isOpen={isOpen}
            onRequestClose={onClose}
            style={customStyles}>
                <div className="flex-v">
                    <div className="is-size-5 text-center has-text-grey-dark mb-24">{`History`}</div>
                    <div className="is-size-6 has-text-grey mb-24">
                    <div className="table-container">
                        <table className="table is-bordered is-striped is-narrow is-hoverable is-fullwidth">
                            <thead>
                                <tr>
                                    <th>
                                        User
                                    </th>
                                    <th>
                                        Action
                                    </th>
                                    <th>
                                        Action date
                                    </th>
                                    <th>
                                        Reason
                                    </th>
                                </tr>
                                </thead>
                                <tbody>
                                    {datas.map((item, i) =>{
                                        return (
                                            <tr key={item.ID}>
                                                <td>
                                                    {item.UserName}
                                                </td>
                                                <td>{item.Action}</td>
                                                <td>{item.DisplayDate}</td>
                                                <td>{item.Remark}</td>
                                            
                                            </tr>
                                        );
                                    })}
                                
                            </tbody>
                        </table>
                    </div>
                    <div className="flex-h flex-between">
                        <button onClick={() => onClose()} className={`mt-24 button is-info is-fullwidth center`}>Close</button>
                    </div>
                </div>
            </div>
        </Modal>
    );
}
export default HistoryModal;